// extracted by mini-css-extract-plugin
export default {"page":"g__page--MqUkz"};